// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__HxaJa","validationTips":"StatementDescriptor_validationTips__1mD0B"};